export default [
  'Account Preferences & Settings',
  'Add Your Contacts',
  'Create Your Contact Groups',
  'Create Your Forms',
  'Automate your Tasks',
]
